module.exports = __webpack_public_path__ + "img/Search.2c8466a0.png";